import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
  openModal: {
    type: Boolean,
    default: false
  },
  modalType: {
    type: String
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.modalType),
    ref: "modal"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(__props.modalType + '-content')
    }, [
      _createElementVNode("span", {
        class: "close-modal",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeModal')))
      }),
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 2)), [
    [_vShow, __props.openModal]
  ])
}
}

})